import { OneOnOneNotes } from 'screens/oneOnOneRabbit/interfaces/OneOnOneNotes';

import { OneOnOneAgendaNotesI } from '../../Agenda/hooks/dataHooks';
import { getOneOnOneInstanceNotesApi, updateOneOnOneInstanceNotesApi } from '../api';

export const oneOnOneNotesValidator = OneOnOneNotes.nullable();

export const getOneOnOneInstanceNotes = async ({
  masterId,
  instanceId,
  isPrivate = false,
}: {
  masterId: number;
  instanceId?: number;
  isPrivate?: boolean;
}) => {
  try {
    const res = await getOneOnOneInstanceNotesApi({ masterId, instanceId, isPrivate });
    const data = oneOnOneNotesValidator.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error fetching one on one notes details ', error);
    // throw new Error(generateErrorMessage(error));
  }
};

export const updateOneOnOneInstanceNotes = async ({
  masterId,
  instanceId,
  isPrivate = false,
  ...rest
}: {
  masterId: number;
  instanceId: number;
  isPrivate?: boolean;
} & OneOnOneAgendaNotesI) => {
  try {
    const res = await updateOneOnOneInstanceNotesApi({ masterId, instanceId, isPrivate, ...rest });
    const data = oneOnOneNotesValidator.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error updating one on one notes details ', error);
    // throw new Error(generateErrorMessage(error));
  }
};
